window.modifyGiftCardQuantity = (element, increase = true) => {
    const inputEl = element.parentElement.getElementsByTagName('input')[0];
    let val = parseInt(inputEl.value);
    if (increase) {
        inputEl.setAttribute('value', val + 1);
    } else if (val > 1) {
        inputEl.setAttribute('value', val - 1);
    }
}

window.validateQtyLimits = (el) => {
    let val = parseInt(el.value);
    const min = el.min;
    const max = el.max;
    val = Math.max(min, Math.min(max, val));
    el.value = val;
    el.setAttribute('value', val);
}

window.updateMsgText = () => {
    const textarea = document.getElementById('custom-message');
    const msgText = document.getElementById('msg-text');
    GiftCardCustomizedMessage = textarea.value;
    msgText.innerHTML = textarea.value.replace(/(?:\r\n|\r|\n)/g, '<br>');
}
updateMsgText();
document.addEventListener('DOMContentLoaded', updateMsgText);

window.togglePersonalizedMessage = () => {
    const checkbox = document.getElementById('showPersonalizedMessageCheckBox');
    const personalizedMessageFormField = document.getElementById('personalizedMessageFormField');
    const personalizedMessageTextArea = document.getElementById('custom-message');
    const personalizedMessagePreview = document.getElementById('personal-msg-container');
    if (checkbox.checked) {
        personalizedMessageTextArea.value = GiftCardCustomizedMessage;
        personalizedMessageFormField.classList.remove('hidden');
        personalizedMessagePreview.classList.remove('hidden');
        updateMsgText();
    } else {
        personalizedMessageFormField.classList.add('hidden');
        personalizedMessageTextArea.value = "";
        personalizedMessagePreview.classList.add('hidden');
    }
}

window.setPreviewImage = (data) => {
    const previewImage = document.getElementById('gift-card-preview-image');
    previewImage.src = data.src;
    previewImage.srcset = data.srcset;
    previewImage.setAttribute('data-srcset', data.srcset);
    previewImage.setAttribute('alt', data.alt);
}